import React, { FC } from 'react'

import { IconNetworkTowerProps } from './IconNetworkTower.types'
import * as Styled from './styles/IconNetworkTower.style'

import { nonThemeableRules } from '../../ruleSet'

const IconNetworkTower: FC<IconNetworkTowerProps> = ({
  size = nonThemeableRules.defaultSize as number as IconNetworkTowerProps['size'],
  isResponsive = false,
}: IconNetworkTowerProps) => {
  return (
    <Styled.IconWrapper size={size} isResponsive={isResponsive}>
      <svg fill='none' viewBox='0 0 48 48' xmlns='http://www.w3.org/2000/svg'>
        <path
          d='m27.97 33.195-10.307 9.833a.25.25 0 0 1-.413-.25l5.87-20.053'
          stroke='#fff'
          strokeLinecap='round'
          strokeMiterlimit='10'
          strokeWidth='2'
        />
        <path
          d='m24.905 22.725 5.867 20.053a.25.25 0 0 1-.412.25l-10.308-9.825'
          stroke='#fff'
          strokeLinecap='round'
          strokeMiterlimit='10'
          strokeWidth='2'
        />
        <path d='M14.845 10.46a13.05 13.05 0 0 0 0 18.482' stroke='#EA1A1A' strokeLinecap='round' strokeLinejoin='round' strokeWidth='2' />
        <path
          d='M10.443 6.61a18.499 18.499 0 0 0 0 26.182M33.178 10.46a13.052 13.052 0 0 1 0 18.482'
          stroke='#EA1A1A'
          strokeLinecap='round'
          strokeLinejoin='round'
          strokeWidth='2'
        />
        <path d='M37.58 6.61a18.499 18.499 0 0 1 0 26.182' stroke='#EA1A1A' strokeLinecap='round' strokeLinejoin='round' strokeWidth='2' />
        <path
          d='M24 16.063h3.395v3.395A3.395 3.395 0 1 1 24 16.063Z'
          stroke='#fff'
          strokeLinecap='round'
          strokeMiterlimit='10'
          strokeWidth='2'
        />
      </svg>
    </Styled.IconWrapper>
  )
}

export default IconNetworkTower
